import React, {useState} from 'react';
import {ExternalLinkIcon} from '../../../icons/Icons';
import CopyButton from '../../cmp/CopyButton';
import {useSelector} from 'react-redux';
import useRefLink from '../../cmp/hooks/useRefLink';
import {FormattedMessage} from 'react-intl';
import ShareBar from '../../cmp/ShareBar';
import {FiShare, FiShare2} from 'react-icons/fi';

function QuickLinks() {
  const quick_links = useSelector((state)=>{
    const ql = state.settings.quick_links
    if(ql && ql.length > 0){
      return ql.filter(({isPrimary})=>!isPrimary)
    }
  })
  if(!quick_links || quick_links.length === 0){
    return null
  }
  return (
      <div className={"mb-2 mt-2"}>
        <h4><FormattedMessage id={"Quick Links"} /></h4>
        <ul className="list-group">
          {
            quick_links.map((item)=>{
                  return <RenderLink key={item.id} title={item.title} url={item.url} />
            })
          }
        </ul>
      </div>
  );
}

function prettifiedLink(url){
  const u = new URL(url)
  const path = u.pathname.endsWith('/') ? u.pathname.substring(0, u.pathname.length - 1) : u.pathname;
  return u.hostname+path
}

function RenderLink({title, url}){
  const [ref_link] = useRefLink(url)
  return  <li className="list-group-item py-3 d-flex align-items-center justify-content-between">
    <div>{
      title ? <div>{title}</div> : null
    }
       <small className="text-muted">
         <a href={ref_link} target={"_blank"} rel={"noreferrer noopener"}>{prettifiedLink(url)}</a>
       </small>
    </div>
     <ShareBar link={ref_link} />
  </li>
}

export default QuickLinks;
